<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    actionText?: string | null;
    actionRoute?: string | null;
    icon?: string | null;
    paragraph?: string | null;
    header: string;
    loader?: boolean;
  }>(),
  {
    actionText: null,
    actionRoute: null,
    icon: null,
    loader: false,
    paragraph: null,
  },
);
</script>

<template>
  <!-- TODO NUXT: z-index matches Vuetify's overlay layer so the page covers app bar and navigation drawer (z-index >= 1000) -->
  <div
    class="fixed inset-0 z-[2400] flex flex-col items-center justify-center gap-6 bg-primary px-8 text-center text-white"
  >
    <UIcon v-if="props.icon" :name="props.icon" aria-hidden="true" class="size-16" />
    <h1 class="text-2xl font-bold">
      {{ header }}
    </h1>
    <UIcon
      v-if="loader"
      name="i-material-symbols-progress-activity-outline-rounded"
      aria-hidden="true"
      class="size-16 animate-spin"
    />
    <p v-if="paragraph" class="max-w-prose text-base" style="word-break: keep-all">
      {{ paragraph }}
    </p>
    <!-- TODO NUXT: Revisit button -->
    <div class="mt-8 flex items-center justify-center gap-4">
      <slot name="actions">
        <UButton
          v-if="props.actionText && props.actionRoute"
          :href="props.actionRoute"
          size="xl"
          color="neutral"
          variant="outline"
        >
          {{ actionText }}
        </UButton>
      </slot>
    </div>
  </div>
</template>
